// client/src/pages/Login.js
import React from 'react';
import LoginForm from '../components/LoginForm';
import '../styles/Login.css';

function Login() {
  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Wilkommen zurück!</h1>
          <p className="text-muted">Jetzt einloggen um auf dein Portfolio zuzugreifen</p>
        </div>
        <LoginForm />
      </div>
    </div>
  );
}

export default Login;

